import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfigurationService } from '../../../_services';
import { Subscription } from 'rxjs';
import { ConfigurationImportProcess } from 'src/app/_models';
import { DesignVersionEnum } from 'src/app/_enums/design-version.enum';

@Component({
  selector: 'app-payoutprocess-import',
  template: `
    <div class="loading-wrapper">
      <div class="loading"></div>
    </div>
    <div class="app-container" appCustomV2DesignLayout>
      <app-snav-menu-controller class="app-side fixed" id="app-side"></app-snav-menu-controller>
      <!-- BEGIN .app-main -->
      <div class="app-main">

        <ng-container *ngIf="pyoImportType === 'V1'">
          <app-old-payout-import-version></app-old-payout-import-version>
        </ng-container>

        <ng-container *ngIf="pyoImportType === 'V2'">
          <app-shared-import-process [configurationData]="configurationData" [urlConfigType]="'PAYOUT'"></app-shared-import-process>
        </ng-container>

      </div>
      <!-- END: .app-main -->
    </div>
  `,
  styleUrls: ['./new-payoutprocess-import.component.css']
})

export class NewPayoutprocessImportComponent implements OnInit {

  customerPuplic_key: string;
  importationConfiguration$: Subscription;
  pyoImportType: 'V1' | 'V2' | null = null;
  configurationData: ConfigurationImportProcess;

  constructor(
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    this.spinnerService.show();
    this.checkCredentials();
    this.getPayoutInvoiceImportationConfiguration();
  }

  checkCredentials() {
    if ((localStorage.getItem('companyId') != null || localStorage.getItem('companyId') !== '') && (localStorage.getItem('application') != null || localStorage.getItem('application') !== '')) {
      if (localStorage.getItem('isCorporate') === 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
    } else {
      this.router.navigate(['/home']);
    }
  }

  getPayoutInvoiceImportationConfiguration() {
    const urlConfig = 'payout_services.configuration';
    this.importationConfiguration$ = this.configurationService.getImportConfiguration(this.customerPuplic_key, urlConfig).subscribe(data => {
      const configurationData = data;
      if (configurationData && configurationData.values && configurationData.values.import_process) {
        const pyoImportacionValue = configurationData.values.import_process.version;
        if ((pyoImportacionValue != null && pyoImportacionValue.trim().length > 0) && (pyoImportacionValue === "V1" || pyoImportacionValue === "V2")) {
          this.configurationData = configurationData;
          this.pyoImportType = pyoImportacionValue;
        } else {
          this.pyoImportType = "V1";
        }
      } else {
        this.pyoImportType = "V1";
      }
      this.spinnerService.hide();
    }, error => {
      this.pyoImportType = "V1";
      console.error('Failed! while trying to get payout invoice importation configuration. ' + error);
      this.spinnerService.hide();
    });
  }

  ngOnDestroy() {
    this.importationConfiguration$.unsubscribe();
  }

}
